import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdRsvpNoteLayoutRoute() {
  return <ModalStack />;
}
